<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Vacances / fermeture</h1>
                    <p>Gestion des slots du fermetures</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.schedule.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer des vacances</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :menus="menus" :active-query="false" :active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>

                            <div></div>
                            <div v-bind:class="[ paginator.sort == 'title' ? 'active' : '', paginator.order ]">
                                <span data-sort="title" @click="setOrder($event)">Titre</span>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'start' ? 'active' : '', paginator.order ]">
                                <span data-sort="start" @click="setOrder($event)">Start</span>
                            </div>
                            <div v-bind:class="[ paginator.sort == 'end' ? 'active' : '', paginator.order ]">
                                <span data-sort="end" @click="setOrder($event)">End</span>
                            </div>
                            <div>
                                <span>Slots</span>
                            </div>
                            <div></div>
                            <div class="actions"></div>
                            <div></div>

                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.schedule.view', item.id )">
                            <div></div>
                            <div data-field="title">{{ item.name }}</div>
                            <div data-field="start">{{ item.start_at }}</div>
                            <div data-field="end">{{ item.end_at }}</div>
                            <div data-field="slots">
                                <label class="label" v-if="item.all_slots">Tous</label>
                                <label class="label scope" v-if="item.slotables && item.all_slots === 0" v-for="slot in item.slotables" v-bind:style="{background:slot.color}">
                                    {{ slot.name.substr(0,1) }}
                                </label>
                            </div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.schedule.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.schedule.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>

    import ScheduleService from '../../reservation/ScheduleService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                dataSelectedFilter: null,
                menus: [
                    {
                        slug: 'calendar',
                        name: 'Slots'
                    },
                    {
                        slug: 'opening-hours',
                        name: 'Horaire ouverture'
                    },
                    {
                        slug: 'closure',
                        name: 'Vacances / Fermeture'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ScheduleService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/closure/Index.vue